export const codeConstants = {
  SET_HTML: "SET_HTML",
  SET_CSS: "SET_CSS",
  SET_JS: "SET_JS",
};

export const layoutConstants = {
  SET_THEME: "SET_THEME",
  SET_VIEW: "SET_VIEW",
};
